import { UserAction } from '@enview/interface/types/actions/UserAction';
import React from 'react';
import ActivityCard from '../ActivityFeed/ActivityCards/ActivityCard';
import { ActivityCardStyle } from '../ActivityFeed/ActivityCards/ActivityCard';
import {
  isElementEmpty,
  serializeToReactElement,
} from '@enview/interface/utils/RichTextAnnotation';
import { useSelector } from 'react-redux';
import { State } from '../../../dux/@types';
import { getCardRef } from '../../../dux';
import {
  PositionStatement,
  PositionType,
} from '@enview/interface/types/bills/PositionStatement';
import CommentCheckCircleIcon from './CommentCheckCircleIcon';

interface PositionActivityCardProps {
  action: UserAction;
  position: PositionStatement;
}

const GREEN = '#2EA270';
const RED = '#DA5151';
const NEUTRAL = '#F79728';

export const PositionActivityCard: React.FC<PositionActivityCardProps> = ({
  action,
  position,
}) => {
  const orgUser = useSelector((state: State) => state.account.organizationUser);
  const ref = useSelector((state: State) => getCardRef(state, action.id));
  const orgWithPosition = orgUser?.organizations.find(
    (org) => org.id === position.orgId,
  )?.name;

  const timeUpdate = new Date(action.updatedAt).toLocaleDateString();
  let iconColor = NEUTRAL;
  const supportsBill = position?.positionType === PositionType.SUPPORT;
  const opposesBill = position?.positionType === PositionType.OPPOSE;
  const positionComment = position.statementJson ? (
    <span>{serializeToReactElement(position.statementJson, orgUser?.id)}</span>
  ) : (
    <span>{position.positionStatement}</span>
  );

  if (supportsBill) {
    iconColor = GREEN;
  } else if (opposesBill) {
    iconColor = RED;
  }

  const content = (
    <div>
      {position && position.positionType !== PositionType.NO_POSITION && (
        <div
          className="position-button mb-4"
          style={{ backgroundColor: supportsBill ? GREEN : RED }}
        >
          {position?.positionType}
        </div>
      )}
      {!isElementEmpty(positionComment) && <span>{positionComment}</span>}
    </div>
  );

  return (
    <ActivityCard
      activityStyle={ActivityCardStyle.BILL_POSITION_STATEMENT}
      content={content}
      icon={<CommentCheckCircleIcon color={iconColor} />}
      refObject={ref}
      subtitle={timeUpdate}
      title={
        <b>{`Position Statement ${
          orgWithPosition ? `by ${orgWithPosition}` : 'Position on Bill'
        }`}</b>
      }
    />
  );
};

export default PositionActivityCard;
